import React, {useState, useRef, useContext, useEffect} from "react"

// context
import {ScrollContext} from "../../context/ScrollContext"

// styling & images
import "./Sidebar.scss"

/**
 * 
 * @param {*} mode: either "search" or "activity" 
 */
function Sidebar(props) {
  // state & ref
  const [fixed, setFixed] = useState(false)
  const refTop = useRef()

  // context
  let scroll = useContext(ScrollContext)

  // scroll side effect
  useEffect(() => {
    if(refTop.current) {
      const position = refTop.current.getBoundingClientRect()
      if(position.top < 0 && fixed !== true) {
        setFixed(true)
      }
      else if(position.top >= 0 && fixed !== false) {
        setFixed(false)
      }
    }
  }, [scroll.timestamp, fixed, setFixed])  

  // render
  return (
    <div id="s-sidebar" ref={refTop} className={props.className}>
      <div id="s-sidebar-inner" className={fixed ? "fixed":""}>
        {props.children}
      </div>
    </div>
  )
}

export default Sidebar